import React from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { findIndex as _findIndex } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Loader from 'components/layout/Loader';
import Modal from 'components/Modal';
import List from 'components/List';

class WhiteLabelAddPlugin extends React.Component {
  addPluggin = pluginId => {
    const { submitPluginActivate, whiteLabelProject } = this.props;
    submitPluginActivate(whiteLabelProject.getId(), pluginId, {});
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      list,
      disabled,
      entity,
    } = this.props;

    const columns = ['ID', messages.name, messages.add];

    let tBody = [];
    if (!list.pending) {
      const whiteLabelPlugins = entity.getPlugins();

      let addablePlugins = [];
      addablePlugins = list.data.list.filter(plugin => {
        if (_findIndex(whiteLabelPlugins, ['id', plugin.id]) === -1) {
          return plugin;
        }

        return null;
      });

      tBody = addablePlugins.map(plugin => {
        const { id, name } = plugin;

        return (
          <tr key={id}>
            <td class="v-align-middle semi-bold">{id}</td>
            <td class="v-align-middle">{name}</td>
            <td class="v-align-middle">
              <Button
                block
                bsStyle="primary"
                onClick={() => {
                  this.addPluggin(id);
                }}
                disabled={disabled}
              >
                {messages.add}
              </Button>
            </td>
          </tr>
        );
      });
    }

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.add_white_label_plugin}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="whiteLabelPlugin"
            url="/api/whitelabelplugins.json"
            list={list}
            iconClass="fa fa-plug"
            title={messages.plugins}
            noRender
          />

          {list.pending ? (
            <Loader />
          ) : (
            <Table responsive hover>
              <thead>
                <tr>
                  {columns.map((column, i) => {
                    return (
                      <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                        {column}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <ReactCSSTransitionGroup
                transitionName="tablerows"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={1}
                component="tbody"
              >
                {tBody}
              </ReactCSSTransitionGroup>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.whiteLabelPlugin,
    formStatus: state.formStatus.pluginActivate,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitPluginActivate: (whiteLabelId, pluginId, data) => {
      formStatusDispatchHelper(
        'whiteLabelEdit',
        '/api/whitelabels/' + whiteLabelId + '/plugins/' + pluginId + '/addTest.json',
        data,
        'put',
        dispatch
      );
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelAddPlugin)
);
